(function ($) {
  // ── Countdown timer ──────────────────────────────────────────
  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function getNextMidnightET() {
    var now = new Date();
    var etNow = new Date(
      now.toLocaleString("en-US", { timeZone: "America/New_York" }),
    );
    var etMid = new Date(etNow);
    etMid.setHours(24, 0, 0, 0);
    return new Date(etMid.getTime() + (now - etNow));
  }

  var endDate = getNextMidnightET();

  function tick() {
    var now = new Date();
    var diff = endDate - now;

    if (diff <= 0) {
      endDate = getNextMidnightET();
      diff = endDate - now;
    }

    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);

    $("#mmd-hours").text(pad(h));
    $("#mmd-minutes").text(pad(m));
    $("#mmd-seconds").text(pad(s));
  }

  tick();
  setInterval(tick, 1000);

  // ── Sticky header offset (set once on load via CSS var) ──────
  var $header = $(".mmd_hero-header");
  document.documentElement.style.setProperty(
    "--mmd-header-h",
    $header.outerHeight() + "px",
  );

  // ── CTA scroll with offset ───────────────────────────────────
  $(".mmd-hero__cta").on("click", function (e) {
    e.preventDefault();
    window.scrollTo({
      top: $("#mmd-bundles").offset().top - 100,
      behavior: "smooth",
    });
  });

  // ── Compact header on scroll ─────────────────────────────────
  var $countdown = $(".mmd-hero__countdown");

  $(window).on("scroll", function () {
    $countdown.toggleClass("is-compact", $(this).scrollTop() > 20);
  });

  // ── Reviews grid slider ──────────────────────────────────────
  var $wrapper = $(".mmd-reviews_grid__wrapper");
  var $cards = $(".mmd_review-box");
  var $prev = $(".mmd_arr--prev");
  var $next = $(".mmd_arr--next");

  function updateArrows() {
    var el = $wrapper[0];
    $prev.toggleClass("disabledArr", el.scrollLeft <= 0);
    $next.toggleClass(
      "disabledArr",
      el.scrollLeft + el.clientWidth >= el.scrollWidth - 1,
    );
  }

  function getActiveIndex() {
    var wrapperLeft = $wrapper[0].getBoundingClientRect().left;
    var closest = 0,
      minDist = Infinity;
    $cards.each(function (i) {
      var dist = Math.abs(this.getBoundingClientRect().left - wrapperLeft);
      if (dist < minDist) {
        minDist = dist;
        closest = i;
      }
    });
    return closest;
  }

  function slideTo(i) {
    i = Math.max(0, Math.min(i, $cards.length - 1));
    var offset =
      $wrapper.scrollLeft() +
      ($cards.eq(i)[0].getBoundingClientRect().left -
        $wrapper[0].getBoundingClientRect().left);
    $wrapper[0].scrollTo({ left: offset, behavior: "smooth" });
  }

  $wrapper.on("scroll", updateArrows);
  updateArrows();

  $prev.on("click", function () {
    slideTo(getActiveIndex() - 1);
  });
  $next.on("click", function () {
    slideTo(getActiveIndex() + 1);
  });
})(jQuery);
